import * as Rx from 'rxjs';
import { map, tap } from 'rxjs/operators';
import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';

import apiService from '../api';
import type { ApiService } from '../api';

class SelectAffiliateService {
  private loadingAffiliates$ = new Rx.BehaviorSubject<boolean>(true);
  private affiliates$ = new Rx.BehaviorSubject<IAffiliateOption[]>([]);

  constructor(private apiService: ApiService) {}

  public getAffiliates = () => this.affiliates$;

  public getIsLoading = () => this.loadingAffiliates$;

  public loadAffiliates = () => {
    this.loadingAffiliates$.next(true);
    return this.apiService.get('reports/affiliates').pipe(
      map(response => response.data),
      tap(data => {
        this.affiliates$.next(data);
        this.loadingAffiliates$.next(false);
      })
    );
  };
}

const selectAffiliateService = new SelectAffiliateService(apiService);
export default selectAffiliateService;
